export default __webpack_public_path__ + "static/media/fasting_veggies@2x.ce9772ad.jpg";